export default class VoyageFuelData {
    constructor({
        id,
        cost,
        ncv,
        tag,
        type,
    }) {
        this.id = id;
        this.cost = cost;
        this.ncv = ncv;
        this.tag = tag;
        this.type = type;
    }
}